import { SerialRequestModel } from '@/models/serial.model'
import SerialClient from '@/clients/serial.client'

export default class SerialService {
    static async checkSerialNumber (data) {
        const serialRequestData = new SerialRequestModel(data)
        return await SerialClient.checkSerialNumber(serialRequestData)
    }
}
